'use client';

import { useAtomValue } from 'jotai';

import type { SearchParamsType } from '@core/Atoms/SearchParams/SearchParams.atom';
import { experimentsAtom } from '@growthBookExperimentation/Atoms/Experiments.atom';
import type { FlagKey } from '@growthBookExperimentation/Entities/FlagKeys.entities';
import { TrackPage } from '@tracking/Components/ClientWrappers/TrackPage';
import type { ListingEvent } from '@tracking/Schemas/Listing/ListingEvent';
import { getExperimentViewedEvents } from '@tracking/Utils/GetExperimentViewedEvents';

interface TrackPlpEventsProps {
  plpEvents: ListingEvent[];
  searchParams: SearchParamsType;
  introCopyExperiment?: boolean;
}

export const TrackPlpEvents: React.FC<TrackPlpEventsProps> = ({
  searchParams,
  plpEvents,
  introCopyExperiment,
}) => {
  const experiments = useAtomValue(experimentsAtom);
  let context: ListingEvent[] = plpEvents;

  const expIds: FlagKey[] = [
    'saved-search-single-filter-impact',
    'saved-search-cta-visibility',
    'unavailable-cars-leadform-experiment',
  ];
  if (introCopyExperiment) {
    expIds.push('plp-intro-copy');
  }

  const experimentViewedEvents = getExperimentViewedEvents(expIds, experiments);
  context = [...context, ...experimentViewedEvents];

  return <TrackPage context={context} searchParams={searchParams} />;
};
